module.exports = __webpack_public_path__ + "img/img6.adfa024d.png";